import { render, staticRenderFns } from "./CollectionProcedure.vue?vue&type=template&id=87b5fa54&scoped=true&"
import script from "./CollectionProcedure.vue?vue&type=script&lang=js&"
export * from "./CollectionProcedure.vue?vue&type=script&lang=js&"
import style0 from "./CollectionProcedure.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CollectionProcedure.vue?vue&type=style&index=1&id=87b5fa54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b5fa54",
  null
  
)

export default component.exports